import React, { createContext, FC, useEffect, useState } from 'react';
import { Button, Flex, Form, Input, notification } from 'antd';
import { NotificationPlacement } from 'antd/es/notification/interface';
import {useNavigate} from 'react-router-dom';
import { EmailInputIcon, EyeIcon, LockIcon, openEyeIcon } from '../../../assets/image/svg';
import { RouteNames } from '../../../router/routeNames';
import { useStoreDispatch } from '../../../store';
import { Login, setAuth, setUserInfo } from '../../../store/users';
import s from './form.module.scss';
import { Checkbox } from '../../../components/Checkbox/Checkbox';
import Icon from '@ant-design/icons/lib/components/Icon';
import { Utils } from '../../../utils';
import socket from "../../../socket";


interface IClickRegistration {
  clickRegistration: () => void
}

const Context = createContext({ name: 'Default' });

const LoginForm: FC<IClickRegistration> = ({ clickRegistration }) => {
  const router = useNavigate();
  const dispatch = useStoreDispatch();
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const [choice, setChoice] = useState<boolean>(false);
  const member: any = localStorage.getItem('_member');
  const [loadingIn , setLoadingIn] = useState(false);

  useEffect(() =>{
    if (member){
      setChoice(true);
      const memberDecrypt = Utils.decrypt(member);
      form.setFieldsValue({
        email: memberDecrypt.email,
        password: memberDecrypt.password
      })
    }
  },[member])

  const onFinish = async (data: any) => {
    const result = await dispatch(Login(data));
    const jRes = JSON.parse(result.payload);
    if (jRes.success === 1) {
      sessionStorage.setItem('_yl105000', jRes.user);
      dispatch(setAuth(true));
      dispatch(setUserInfo(jRes.name));
      router(RouteNames.MAIN);
    }
    if (jRes.success === 0) {
      dispatch(setAuth(false));
      openNotification('topRight', jRes.message);
    }
  };

  const openNotification = (placement: NotificationPlacement, message: string) => {
    api.error({
      message: `Ошибка`,
      description: <Context.Consumer>{({ name }) => message}</Context.Consumer>,
      placement,
    });
  };

  const clickForgetPassword = () => {
    router(RouteNames.FORGET_PASSWORD);
  };

  return (
    <div className={s.container}>
      {contextHolder}
      <Flex justify='center' vertical>
        <h1
          style={{ marginBottom: 30, textAlign: 'center', fontFamily: 'Manrope', fontSize: 32, fontWeight: 700 }}>Добро
          пожаловать!</h1>
        <Form
          form={form}
          name="normal_login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Пожалуйста, введите свое имя пользователя!' }]}>
            <Input
              prefix={<EmailInputIcon />}
              placeholder="Email"
              style={{ marginBottom: 10 }}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Пожалуйста, введите свой пароль!' }]}
          >
            <Input.Password
              prefix={<Icon component={LockIcon} />}
              type="password"
              placeholder="Пароль"
              iconRender={(visible) => (visible ? <Icon component={openEyeIcon} /> : <Icon component={EyeIcon} />)}
            />
          </Form.Item>
          <Form.Item>
            <Flex justify={'space-between'} align={'center'}>
              <Flex gap={5} align={'center'}>
                  <Checkbox isChoice={choice} onChange={setChoice} style={{}} />
                  <p>Запомнить</p>
              </Flex>
              <Flex gap={5} align={'center'}>
                <p className={s.color} onClick={clickForgetPassword}>
                  Забыли пароль
                </p>
              </Flex>
            </Flex>
          </Form.Item>
          <Form.Item>
            <Flex align={'center'} vertical gap={'15px'}>
              <Button type='primary' style={{ width: '100%' }} htmlType={'submit'}
              loading={loadingIn}>
                Вход
              </Button>
              <p style={{ color: '#0055FF' }} onClick={clickRegistration} className={s.ahref}>или зарегистрируйтесь</p>
            </Flex>
          </Form.Item>
        </Form>
      </Flex>
    </div>
  );
};

export default LoginForm;
